var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
'component',
'component__loading',
_vm.size ? ("component__loading--" + _vm.size) : ''
]},[_vm._m(0),(_vm.$slots.default)?[_c('div',{staticClass:"component__loading_text"},[_vm._t("default")],2)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component__loading_icon"},[_c('div'),_c('div'),_c('div'),_c('div')])}]

export { render, staticRenderFns }